import EditorLinkModal from './EditorLinkModal';
import EditorImgModal from './EditorImgModal';
import EditorVideoModal from './EditorVideoModal';
import EditorAudioModal from './EditorAudioModal';
import EditorFormulaModal from './EditorFormulaModal';
import EditorFilmModal, { getFilmScoreText } from './EditorFilmModal';

export {
  EditorLinkModal,
  EditorImgModal,
  EditorVideoModal,
  EditorAudioModal,
  EditorFormulaModal,
  EditorFilmModal,
  getFilmScoreText,
};

export default {};



// WEBPACK FOOTER //
// ./src/components/EditorModal/index.js